import { render, staticRenderFns } from "./FederationDashboard.vue?vue&type=template&id=16677cf9"
import script from "./FederationDashboard.vue?vue&type=script&lang=js"
export * from "./FederationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports